import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import classNames from "classnames";
import dompurify from "isomorphic-dompurify";
import { FormattedPrice, Separator, Txt, useTranslations } from "@jti/ui";
import { PriceBlockTax } from "../PriceBlockTax/PriceBlockTax";
import styles from "../Prices.module.scss";
const { sanitize } = dompurify;
export const PriceBlock = ({ value, totalTitle = false, currency, shopCurrency, testId, title = "", subtitle = "", tax, taxInfo, topSeparator = false, isSummary = false, isDiscount = false, inProgress = false, isShortSummary = false, isOriginalPrice = false, originalPrice, }) => {
    const containerClassName = classNames(styles.columns, {
        [styles.total]: totalTitle,
        [styles.totalNoPadding]: isShortSummary,
    });
    const titleClassName = classNames({
        [styles.totalTitle]: totalTitle,
        [styles.subtotalTitle]: !totalTitle,
        [styles.titleShortSummary]: isShortSummary,
    });
    const valueClassName = classNames({
        [styles.sectionTotalValue]: totalTitle,
        [styles.subtotal]: !totalTitle,
        [styles.totalValue]: totalTitle,
        [styles.totalValueBold]: isSummary,
        [styles.totalTitleShort]: isShortSummary,
        [styles.originalPrice]: isOriginalPrice,
        [styles.valueShortSummary]: isShortSummary && !totalTitle,
    });
    const valueContainerClassNames = classNames(styles.valueContainer, { [styles.inProgress]: inProgress });
    const { __ } = useTranslations();
    if (!value && value !== 0) {
        return null;
    }
    const SubtitleRow = () => (subtitle ? _jsx("div", { className: styles.subtitle, children: subtitle }) : null);
    const currencyCode = typeof currency === "object" ? currency.code : currency;
    const formattedValue = isDiscount && value > 0 ? -value : value;
    const isPriceUnavailable = value === -1 && !isDiscount;
    const price = isPriceUnavailable ? (`${__("cart.prices.na")} `) : (_jsx(FormattedPrice, { value: formattedValue, currency: currencyCode || shopCurrency.code }));
    const getTaxesClassName = (withTaxInfo) => classNames(styles.taxes, {
        [styles.taxesInfo]: withTaxInfo,
        [styles.taxesInfoShortSummary]: isShortSummary,
    });
    return (_jsxs(_Fragment, { children: [topSeparator ? (_jsx(Separator, { variant: "variant2", containerClassName: classNames({ [styles.shortSummarySeparator]: isShortSummary }) })) : null, _jsxs("div", { className: containerClassName, children: [_jsxs("div", { children: [_jsx("div", { className: titleClassName, children: title }), _jsx(SubtitleRow, {})] }), _jsxs("div", { className: valueContainerClassNames, children: [_jsx(Txt, { className: valueClassName, dataTestId: testId, children: price }), originalPrice, _jsx(PriceBlockTax, { className: getTaxesClassName(), tax: tax, currencyCode: shopCurrency.code })] }), taxInfo?.visible && !!taxInfo?.message.length && (_jsx("div", { className: getTaxesClassName(true), dangerouslySetInnerHTML: { __html: sanitize(taxInfo.message) } }))] })] }));
};
//# sourceMappingURL=PriceBlock.js.map